import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router, RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { fromEvent, Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

import { CampaignYearPipe } from '../../pipes/campaignYear.pipe';
import { Campaign } from '../../models/campaign.model';
import { Page } from '../../models/page.model';
import { CampaignService } from '../../services/campaign.service';
import { CampaignEditComponent } from './campaign-edit.component';
import { TranslatePipe } from '../../pipes/translate.pipe';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PaginationModule } from 'ngx-bootstrap/pagination';

@Component({
  standalone: true,
  selector: 'campaigns-cmp',
  templateUrl: 'campaigns.component.html',
  imports: [RouterLink, RouterLinkActive, RouterOutlet, CampaignEditComponent, CampaignYearPipe, TranslatePipe, CommonModule, FormsModule, PaginationModule],
  providers: [CampaignService],
})
export class CampaignComponent implements OnInit, AfterViewInit {
  error: any;
  @ViewChild('filter') filterElement: ElementRef;

  public rows: Array<any> = [];

  public page: number = 1;
  public itemsPerPage: number = 10;
  public maxSize: number = 5;
  public numPages: number = 1;
  public length: number = 0;
  public filter: string = '';

  constructor(
    private campaignService: CampaignService,
    private router: Router,
  ) {}

  getCampaignsPaginated(pageIndex: number, sortColumnName: string, sortColumnOrder: string, filter: string) {
    this.campaignService
      .getCampaignsAdvanced(pageIndex, this.itemsPerPage, sortColumnName, sortColumnOrder, filter)
      .subscribe((page) => this.handlePage(page));
  }

  handlePage(page: Page<Campaign>) {
    this.rows = page.content;
    this.numPages = page.totalPages;
    this.length = page.totalElements;
  }

  addCampaign() {
    this.router.navigate(['/campaigns', 'new']);
  }

  deleteCampaign(campaign: Campaign, event: any) {
    event.stopPropagation();
    // FIXME traiter les erreurs
    this.campaignService.delete(campaign).subscribe(
      (res) => {
        this.onChangeTable();
      },
      (error) => (this.error = error),
    );
  }

  editCampaign(campaign: Campaign, event: any) {
    this.router.navigate(['/campaigns', 'edit', campaign.id]);
  }

  ngOnInit() {
    this.onChangeTable();
  }

  ngAfterViewInit() {
    fromEvent(this.filterElement.nativeElement, 'keyup')
      .pipe(debounceTime(500), distinctUntilChanged())
      .subscribe((term: any) => {
        const filter = <string>term.target.value;
        if (filter.length === 4) {
          this.filter = filter;
        } else {
          this.filter = '';
        }
        this.updateFilters();
      });
  }

  updateFilters() {
    // reset la page à la première et update la table
    // FIXME faire mieux : suspendre le traitement des changements ?
    if (this.page === 1) {
      this.onChangeTable();
    } else {
      // le biding (pagechanged) du contrôle de pagination va appeler onChangeTable
      this.page = 1;
    }
  }

  onChangeTable(page: any = { page: this.page, itemsPerPage: this.itemsPerPage }): any {
    const pageNumber = page.page;
    this.getCampaignsPaginated(pageNumber, 'id', 'desc', this.filter);
  }
}
